import { render, staticRenderFns } from "./ExhibitorDetail.vue?vue&type=template&id=fb0daab4&"
import script from "./ExhibitorDetail.vue?vue&type=script&lang=js&"
export * from "./ExhibitorDetail.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitorDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports